export const menuTitlesMap = {
    tables: "Рабочие места",
    stoyki_podkatnie: "Стойки подкатные",
    stoli_podkatnie: "Столы подкатные",
    telezhki: "Тележки",
    tumbi: "Тумбы",
    stellazhi: "Стеллажи",
    verstaki: "Верстаки слесарные",
    wardrobes: "Шкафы",
};
